import Phaser from 'phaser';

/** Phaser tween'lerini Promise ile sarmalar */
export function tweenPromise(
  scene: Phaser.Scene,
  config: Phaser.Types.Tweens.TweenBuilderConfig,
): Promise<void> {
  return new Promise((resolve) => {
    scene.tweens.add({
      ...config,
      onComplete: () => resolve(),
    });
  });
}

export function delayPromise(scene: Phaser.Scene, ms: number): Promise<void> {
  return new Promise((resolve) => {
    scene.time.delayedCall(ms, () => resolve());
  });
}

export function killViewTweens(scene: Phaser.Scene, ...targets: Phaser.GameObjects.GameObject[]): void {
  targets.forEach((target) => scene.tweens.killTweensOf(target));
}
